import React from "react";
import { Box, Heading, Text, Container } from "@chakra-ui/react";
import NavbarTopFirst from "../Navbar/NavbarTopFirstt";
import NavbarTopSecond from "../Navbar/NavbarTopSecond";
import Footer from "../Footer/Footer";

function Reviews() {
  return (
    <Box>
      <NavbarTopFirst />
      <NavbarTopSecond />
      <Box
        pt="130px" // Adjust padding top to be below both navbars
        minHeight="100vh"
        bg="gray.100" // Attractive background color
        textAlign="center"
      >
        <Container maxW="container.md" py={10}>
          <Heading mb={4}>Google Reviews Page</Heading>
          <Text fontSize="lg">
            This is the Google Reviews page. Content coming soon!
          </Text>
        </Container>
      </Box>
      <Footer />
    </Box>
  );
}

export default Reviews; 